import { EntityType } from './entity-type';
import { Request } from './request';
import { Response } from './response';

export enum ColumnSetupRank {
  Default = 1,
}

export interface ColumnSetupColumn {
  ID: string;
  Header: string | null;
  Template: string | null;
  Width: number;
}

export interface ColumnSetup {
  Key: string | null;
  Rank: number;
  EntityType: EntityType;
  Name?: string;
  Columns: ColumnSetupColumn[];
}

export interface ColumnSetupViewReadRequest extends Request {
  View: {
    EntityType: EntityType;
  };
}

export interface ColumnSetupViewSaveRequest extends Request {
  View: {
    ColumnSetup: ColumnSetup;
  };
}

export interface ColumnSetupViewResponse extends Response {
  View?: {
    ColumnSetup: ColumnSetup | null;
  };
}
